module.exports = __webpack_public_path__ + "static/media/LocationTile.a87562ca.jpg";